var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0V0z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    stroke: "#000",
    strokeWidth: 1.406,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19.414c-2.344-3.516-6.445-8.281-6.445-12.383A6.453 6.453 0 0 1 10 .586a6.453 6.453 0 0 1 6.445 6.445c0 4.102-4.101 8.867-6.445 12.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.96a2.933 2.933 0 0 1-2.93-2.929A2.933 2.933 0 0 1 10 4.101a2.933 2.933 0 0 1 2.93 2.93A2.933 2.933 0 0 1 10 9.961z"
  }))));
};
export default SvgLocation;